module.exports = __webpack_public_path__ + "static/media/marca-restaurant.7c7c7070.png";